<template>
  <div class="container bg-light my-3 py-3 px-4">

    <div class="row">
      <div class="col-12">
        <h2 class="ms-4 text-start">Create site</h2>
        <hr>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site name"
          placeholder="Site Name"
          @input="(e) => this.siteInfo.site = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
        type="text"
        label="Enter site icon"
        placeholder="Site Icon"
        @input="(e) => this.siteInfo.site_icon = e.target.value"
        />
        <a 
          href="https://api.flutter.dev/flutter/material/Icons-class.html"
          target="blank"
          class="btn btn-sm btn-link mt-0 py-0"
        >
          See the icons reference here
        </a>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site color"
          placeholder="Site Color"
          @input="handleColorInput"
        />
        <span 
          style="font-size: .8rem" 
          class="text-muted mx-2"
        >
          e.g. 0xFF4c505b, 0xFF000000, 0xFF4a505b
        </span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site description"
          placeholder="Site Description"
          @input="(e) => this.siteInfo.site_text = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter token url"
          placeholder="Token url"
          @input="(e) => this.siteInfo.token_url = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site url"
          placeholder="Site url"
          @input="(e) => this.siteInfo.web_url = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="number"
          label="Enter site order"
          placeholder="Site order"
          @input="(e) => this.siteInfo.order = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-multiselect 
          ref="sites"
          :initialValue="initialSiteTypes"
          placeholderToTag="Add"
          placeholder="Site types"
          name="name"
          label="Grant this user permision to smartmatic services"
          :multipleSelection="false"
          :closeOnSelect="true"
          :optionsToSelect="sitesToAdd"
          @handleAddTagging="addTag"
        />
      </div>
    </div>

    <div class="row my-4">
      <div class="col-6 col-lg-3">
        <button class="btn btn-outline-primary w-100" @click="goBack">
          Dismiss
        </button>
      </div>
      <div class="col-6 col-lg-3">
        <button 
          :disabled="disableCreateButton"
          class="btn btn-primary w-100" 
          @click="handleCreateSite"
        >
          Create
        </button>
      </div>
    </div>

  </div>
</template>
<script>
import caSmttInput from '../../components/ca-smtt-input.vue'
import CaSmttMultiselect from '../../components/ca-smtt-multiselect.vue'
import { getAllSiteTypes } from '../../services/sitesTypes/sites_types.api'
import { createSite } from '../../services/sites/site.api'

export default {
  data() {
    return {
      siteInfo: {
        site: null,
        typeSiteId: null,
        site_icon: null,
        site_color: null,
        site_text: null,
        web_url: null,
        token_url: null,
        order: null
      },
      initialSiteTypes: [],
      sitesToAdd: [],
      disableCreateButton: false,
    }
  },
  async mounted() {
    await this.getSiteTypes()
  },
  components: { caSmttInput, CaSmttMultiselect },
  methods: {
    handleColorInput(e) {
      this.siteInfo.site_color = e.target.value
      if (
        !(this.siteInfo.site_color.toLowerCase().startsWith("0xff"))
      ) return this.disableCreateButton = true
      this.disableCreateButton = false
    },
    async getSiteTypes() {
      try {
        const { data } = await getAllSiteTypes()
        this.sitesToAdd = data.typeSites.map(site => {
          const splitted = site.type.split('_')
          let capitalizeEach = []
          for (const word of splitted) {
            capitalizeEach.push(word[0].toUpperCase() + word.slice(1))
          }
          const siteType = capitalizeEach.join(' ')
          return {code: site.id, name: siteType}
        })
      } catch (error) {
        console.log(error)
      }
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.sitesToAdd.push(tag)
      this.initialSiteTypes.push(tag)
    },
    goBack() {
      this.$router.back()
    },
    async handleCreateSite() {
      this.siteInfo.typeSiteId = this.$refs['sites'].value.code
      try {
        await createSite(this.siteInfo)
        this.$toast.open({
          message: 'Site Successfully Created',
          type: 'success'
        })
        this.$router.back()
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: 'An error occurred',
          type: 'error'
        })
      }
    },
  },
}
</script>